import { StatsMetrics } from '../models/dashboardModels';
import {
  VISIT_STATUS,
  VisitPreSaleState,
} from '../../../constants/visitsConstants';

interface StatusMap {
  pending_approval: string;
  done: string;
  cancelled: string;
  rescheduled: string;
  scheduled: string;
}

export const toStatsMetrics = (
  visits: { status: string; counter: number }[],
  statusMap: StatusMap,
): StatsMetrics => ({
  pending_approval:
    visits.find((f) => f.status === statusMap.pending_approval)?.counter ?? 0,
  done: visits.find((f) => f.status === statusMap.done)?.counter ?? 0,
  cancelled:
    visits.find((f) => f.status === statusMap.cancelled)?.counter ?? 0,
  rescheduled:
    visits.find((f) => f.status === statusMap.rescheduled)?.counter ?? 0,
  scheduled:
    visits.find((f) => f.status === statusMap.scheduled)?.counter ?? 0,
  total: visits.reduce((sum, v) => sum + +v.counter, 0),
});

export const VISIT_STATUS_MAP: StatusMap = {
  pending_approval: VISIT_STATUS.PENDING_APPROVAL,
  done: VISIT_STATUS.DONE,
  cancelled: VISIT_STATUS.CANCELLED,
  rescheduled: VISIT_STATUS.RESCHEDULED,
  scheduled: VISIT_STATUS.SCHEDULED,
};

export const PRE_SALE_STATUS_MAP: StatusMap = {
  pending_approval: VisitPreSaleState.PENDING_APPROVAL,
  done: VisitPreSaleState.DONE,
  cancelled: VisitPreSaleState.DELETED,
  rescheduled: VisitPreSaleState.RESCHEDULED,
  scheduled: VisitPreSaleState.SCHEDULED,
};
